import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Snackbar,
  Alert,
} from '@mui/material';
import { Edit as EditIcon, Image as ImageIcon } from '@mui/icons-material';
import api from '../api/api';
import LogoVeterinaria from './LogoVeterinaria';
import { useUserData } from '../hooks/useUserData'; // Ajusta la ruta según tu estructura

const PetPerfil = () => {
  const [petData, setPetData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openLogoModal, setOpenLogoModal] = useState(false);
  const [logoPreviewError, setLogoPreviewError] = useState(false);
  const [logoKey, setLogoKey] = useState(Date.now());
  const API_URL = "http://localhost:8000";

  const [formData, setFormData] = useState({
    nombre_veterinaria: '',
    direccion_pet: '',
    telefonos_pet: '',
    url_web: '',
    email_pet: '',
    url_facebook: '',
    url_twitter: '',
    url_instagram: '',
    nombre_contacto_pet: '',
    porcentaje_iva: '',
    categoria: '',
    url_logo: '',
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userData = useUserData();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  console.log("Renderizado - URL actual del logo:", formData.url_logo);

  // Cargar datos de Pet
  useEffect(() => {
    const fetchPetData = async () => {
      if (!userData.id_pet) return;
      try {
        setLoading(true);
        const response = await api.get(`/pets/${userData.id_pet}`);
        const pet = response.data;

        console.log("Datos recibidos de la API:", pet); // LOG DE INSPECCIÓN
        if (!pet || !pet.id_pet) throw new Error('Datos inválidos');

        setPetData(pet);
        setFormData({
          nombre_veterinaria: pet.nombre_veterinaria || '',
          direccion_pet: pet.direccion_pet || '',
          telefonos_pet: pet.telefonos_pet || '',
          url_web: pet.url_web || '',
          email_pet: pet.email_pet || '',
          url_facebook: pet.url_facebook || '',
          url_twitter: pet.url_twitter || '',
          url_instagram: pet.url_instagram || '',
          nombre_contacto_pet: pet.nombre_contacto_pet || '',
          porcentaje_iva: pet.porcentaje_iva || '',
          categoria: pet.categoria || '',
          url_logo: pet.url_logo || '',
        });
      } catch (err) {
        console.error('Error al cargar pet:', err);
        mostrarMensaje('No se pudieron cargar los datos de la veterinaria', 'error');
      } finally {
        setLoading(false);
      }
    };
    fetchPetData();
  }, [userData.id_pet]);

  const mostrarMensaje = (mensaje, severity = 'success') => {
    setSnackbarMessage(mensaje);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  // Abrir/cerrar modal edición general
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  // Guardar cambios generales (sin logo)
  const handleSave = async () => {
    if (!formData.nombre_veterinaria.trim()) {
      mostrarMensaje('El nombre de la veterinaria es obligatorio', 'error');
      return;
    }

    try {
      const payload = {
        nombre_veterinaria: formData.nombre_veterinaria.trim(),
        direccion_pet: formData.direccion_pet || null,
        telefonos_pet: formData.telefonos_pet || null,
        url_web: formData.url_web || null,
        email_pet: formData.email_pet || null,
        url_facebook: formData.url_facebook || null,
        url_twitter: formData.url_twitter || null,
        url_instagram: formData.url_instagram || null,
        nombre_contacto_pet: formData.nombre_contacto_pet || null,
        porcentaje_iva: formData.porcentaje_iva ? parseFloat(formData.porcentaje_iva) : null,
        categoria: formData.categoria ? parseInt(formData.categoria) : null,
        url_logo: formData.url_logo || null,
      };

      const response = await api.put(`/pets/${userData.id_pet}`, payload);
      setPetData(response.data);
      setFormData({
        ...formData,
        ...response.data,
      });

      mostrarMensaje('Perfil actualizado correctamente');
      handleCloseModal();
    } catch (err) {
      mostrarMensaje('Error al guardar cambios', 'error');
      console.error(err);
    }
  };

  // Formatear timestamp
  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    return new Date(timestamp).toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Perfil de la Veterinaria
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 8 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error" sx={{ my: 4 }}>
          {error}
        </Alert>
      ) : petData ? (
        <Box component="form" sx={{ display: 'grid', gap: 3 }}>
          {/* Sección Logo */}
          <Box sx={{ mb: 4 }}>
  <Typography variant="h6" gutterBottom>
    Logo de la Clínica
  </Typography>

  <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
    {formData.url_logo ? (
      <Box sx={{ position: 'relative' }}>
        <img
          key={logoKey}
          src={`${API_URL}/static/logos/${formData.url_logo}`}
          alt="Logo de la veterinaria"
          style={{
            maxHeight: 140,
            maxWidth: 260,
            objectFit: 'contain',
            borderRadius: 12,
            border: '1px solid #e0e7ff',
            background: '#f8fafc',
            padding: 8,
          }}
          onLoad={() => console.log("✅ Imagen cargada con éxito:", `/static/logos/${formData.url_logo}`)}
                    onError={(e) => {
                      console.error("❌ Error cargando imagen en la ruta:", e.target.src);
                      setLogoPreviewError(true);
                    }}
        />
        {logoPreviewError && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              bgcolor: 'rgba(0,0,0,0.65)',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 12,
              fontSize: '0.9rem',
              textAlign: 'center',
              p: 2,
            }}
          >
            No se pudo cargar la imagen
          </Box>
        )}
      </Box>
    ) : (
      <Box
        sx={{
          width: 260,
          height: 140,
          bgcolor: '#f1f5f9',
          border: '2px dashed #cbd5e1',
          borderRadius: 12,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#64748b',
        }}
      >
        <ImageIcon sx={{ fontSize: 48, color: '#94a3b8', mb: 1 }} />
        <Typography variant="body2">Sin logo cargado</Typography>
      </Box>
    )}

    <Button
      variant="contained"
      startIcon={<EditIcon />}
      onClick={() => setOpenLogoModal(true)}
      sx={{ height: 'fit-content' }}
    >
      {formData.url_logo ? 'Cambiar logo' : 'Subir logo'}
    </Button>
  </Box>

  <TextField
    label="Nombre del archivo logo"
    value={formData.url_logo || '—'}
    fullWidth
    size="small"
    sx={{ mt: 2 }}
    InputProps={{ readOnly: true }}
    helperText="El archivo se almacena en /static/logos/"
  />
</Box>

          {/* Resto de campos */}
          <TextField
            label="Nombre de la Veterinaria"
            value={formData.nombre_veterinaria}
            InputProps={{ readOnly: true }}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="Dirección"
            value={formData.direccion_pet || 'N/A'}
            InputProps={{ readOnly: true }}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="Teléfonos"
            value={formData.telefonos_pet || 'N/A'}
            InputProps={{ readOnly: true }}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="Email"
            value={formData.email_pet || 'N/A'}
            InputProps={{ readOnly: true }}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="Sitio Web"
            value={formData.url_web || 'N/A'}
            InputProps={{ readOnly: true }}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="Contacto"
            value={formData.nombre_contacto_pet || 'N/A'}
            InputProps={{ readOnly: true }}
            variant="outlined"
            fullWidth
          />
          {/* 
          <TextField
            label="Porcentaje IVA"
            value={formData.porcentaje_iva || 'N/A'}
            InputProps={{ readOnly: true }}
            variant="outlined"
            fullWidth
          />
          
          <TextField
            label="Categoría"
            value={formData.categoria || 'N/A'}
            InputProps={{ readOnly: true }}
            variant="outlined"
            fullWidth
          />
          */}
          <TextField
            label="Creado"
            value={formatDate(petData.createdAt)}
            InputProps={{ readOnly: true }}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="Última actualización"
            value={formatDate(petData.updatedAt)}
            InputProps={{ readOnly: true }}
            variant="outlined"
            fullWidth
          />

          <Button
            variant="contained"
            color="primary"
            startIcon={<EditIcon />}
            onClick={handleOpenModal}
            sx={{ mt: 3 }}
          >
            Editar perfil
          </Button>
        </Box>
      ) : null}

       {/* Modal de edición general */}
      <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="sm">
        <DialogTitle>Editar Perfil de Veterinaria</DialogTitle>
                  <DialogContent>
                    <TextField
                      label="Nombre de la Veterinaria"
                      fullWidth
                      value={formData.nombre_veterinaria}
                      onChange={(e) => setFormData({ ...formData, nombre_veterinaria: e.target.value })}
                      sx={{ mt: 2 }}
                      required
                      error={!formData.nombre_veterinaria}
                      helperText={!formData.nombre_veterinaria ? 'Este campo es obligatorio' : ''}
                    />
                    <TextField
                      label="Dirección"
                      fullWidth
                      value={formData.direccion_pet}
                      onChange={(e) => setFormData({ ...formData, direccion_pet: e.target.value })}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      label="Teléfonos"
                      fullWidth
                      value={formData.telefonos_pet}
                      onChange={(e) => setFormData({ ...formData, telefonos_pet: e.target.value })}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      label="Sitio Web"
                      fullWidth
                      value={formData.url_web}
                      onChange={(e) => setFormData({ ...formData, url_web: e.target.value })}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      label="Email"
                      fullWidth
                      value={formData.email_pet}
                      onChange={(e) => setFormData({ ...formData, email_pet: e.target.value })}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      label="Facebook"
                      fullWidth
                      value={formData.url_facebook}
                      onChange={(e) => setFormData({ ...formData, url_facebook: e.target.value })}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      label="Twitter"
                      fullWidth
                      value={formData.url_twitter}
                      onChange={(e) => setFormData({ ...formData, url_twitter: e.target.value })}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      label="Instagram"
                      fullWidth
                      value={formData.url_instagram}
                      onChange={(e) => setFormData({ ...formData, url_instagram: e.target.value })}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      label="Contacto"
                      fullWidth
                      value={formData.nombre_contacto_pet}
                      onChange={(e) => setFormData({ ...formData, nombre_contacto_pet: e.target.value })}
                      sx={{ mt: 2 }}
                    />
                    {/*  No se que es taba pensando cuando lo coloque de el viejo villa
                    <TextField
                      label="Porcentaje IVA"
                      fullWidth
                      value={formData.porcentaje_iva}
                      onChange={(e) => setFormData({ ...formData, porcentaje_iva: e.target.value })}
                      type="number"
                      sx={{ mt: 2 }}
                    />
                    
                    <TextField
                      label="Categoría"
                      fullWidth
                      value={formData.categoria}
                      onChange={(e) => setFormData({ ...formData, categoria: e.target.value })}
                      type="number"
                      sx={{ mt: 2 }}
                    />
                    
                    <TextField
                      label="URL Logo"
                      fullWidth
                      value={formData.url_logo}
                      onChange={(e) => setFormData({ ...formData, url_logo: e.target.value })}
                      sx={{ mt: 2 }}
                    />
                    */}
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseModal}>Cancelar</Button>
                    <Button
                      onClick={handleSave}
                      variant="contained"
                      disabled={!formData.nombre_veterinaria}
                    >
                      Guardar
                    </Button>
                  </DialogActions>
      </Dialog>

      {/* Modal de gestión de logo */}
      <LogoVeterinaria
  open={openLogoModal}
  onClose={() => setOpenLogoModal(false)}
  onSuccess={(nuevoFilename) => {
    console.log("Hijo (LogoVeterinaria) devolvió:", nuevoFilename); // LOG CRÍTICO
  setLogoPreviewError(false);
  setLogoKey(Date.now());
  setFormData((prev) => ({ ...prev, url_logo: nuevoFilename }));
  setPetData((prev) => ({ ...prev, url_logo: nuevoFilename }));
  mostrarMensaje('Logo actualizado correctamente', 'success');
  setOpenLogoModal(false);
}}
  currentLogoFilename={formData.url_logo || null}
/>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default PetPerfil;